angular.module('app.controllers').controller('HelpCtrl', () => {});
